export default "__VITE_ASSET__acf1e19c__"